<template>
    <UApp :locale="uiLocale">
        <component :is="layout">
            <router-view />
        </component>
    </UApp>
</template>

<script lang="ts" setup>
    import { computed } from 'vue'
    import { useRoute } from 'vue-router'
    import { useI18n } from 'vue-i18n'
    import * as locales from '@nuxt/ui/locale'

    import Blank    from '@/layouts/Blank.vue'
    import Calendar from '@/layouts/Calendar.vue'
    import Mail     from '@/layouts/Mail.vue'
    import Settings from '@/layouts/Settings.vue'

    const route = useRoute()
    const { locale } = useI18n()

    // Keep Nuxt UI's built-in component texts in sync with the vue-i18n locale.
    const uiLocale = computed(() => (locales as Record<string, typeof locales.en>)[locale.value] ?? locales.en)

    // Four frames, one per kind of screen: the mailbox, the calendar, the
    // settings section and the sign-in page. Every route names the one it wants
    // (router/index.ts); the mailbox is what an unnamed one gets, since that is
    // where the app opens.
    const layouts = { Blank, Calendar, Mail, Settings }
    const layout  = computed(() => layouts[(route.meta.layout as keyof typeof layouts) ?? 'Mail'])
</script>
